<template>
  <section class="content">
      <!-- <div class="box box-info"> -->
        <form >
            <website ref="website"/>
            <div class="name">
      This is WishList
      </div>
    <footerWebsite ref="footerWebsite"/>
</form>
    <!-- </div> -->
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import Dataview from 'primevue/dataview'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'journalEntry',
  props: ['journal'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    accountMasterDialog,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    Dataview,
    website,
    footerWebsite
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// wishlist.vue?0a7af59f